import React from 'react';
import type { Plan } from '../data/plans';
type PlanCardProps = {
  plan: Plan;
  selected: boolean;
  onSelect: () => void;
  onCheckout: () => void;
  recommended?: boolean;
};
export function PlanCard({
  plan,
  selected,
  onSelect,
  onCheckout,
  recommended = false
}: PlanCardProps) {
  return <div role="radio" aria-checked={selected} tabIndex={0} onClick={onSelect} onKeyDown={event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect();
    }
  }} className={`relative flex cursor-pointer flex-col rounded-[14px] p-5 transition-colors duration-150 ease-out ${recommended ? 'md:-my-[6px] md:pb-6 md:pt-6' : ''}`} style={{
    border: recommended ? `3px solid ${selected ? '#12A05A' : 'rgba(18,160,90,0.55)'}` : `2px solid ${selected ? 'var(--ink)' : 'rgba(20,17,15,0.25)'}`,
    backgroundColor: recommended ? '#F1E6D6' : 'transparent'
  }} data-id="element-47" data-mp="wap7rp9q9asd">
      {recommended ? <span className="absolute -top-[11px] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-[999px] bg-[#12A05A] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-48" data-mp="3f2q3e0c7x1hy">
          Most popular
        </span> : null}

      <p className={`text-[13px] uppercase tracking-[0.14em] ${recommended ? 'font-semibold text-ink' : 'font-semibold text-ink/60'}`} data-id="element-49" data-mp="3125mj9pv5fr3">
        {plan.name}
      </p>

      <div className="mt-2 flex flex-wrap items-baseline gap-x-2 gap-y-2" data-id="element-50" data-mp="3ssbjn2ymv2ma">
        <span className="text-[18px] font-medium text-ink/40 line-through" data-id="element-51" data-mp="3o23ib8j42ia2">${plan.compareAt}</span>
        <span className={`font-extrabold leading-none text-ink ${recommended ? 'text-[44px]' : 'text-[38px]'}`} data-id="element-52" data-mp="3k0hyf385t3qd">
          ${plan.price}
        </span>
        <span className="text-[12px] font-bold uppercase tracking-[0.04em] text-[#12A05A]" data-id="element-53" data-mp="keupddh3eno3">
          Save 90%
        </span>
      </div>

      <ul className="mt-5 space-y-3 text-left text-[15px]" data-id="element-54" data-mp="29tvsi4hijtgh">
        {plan.features.map(feature => <li key={feature.label} className="flex items-start gap-2" data-id="element-55" data-mp="2es6yg44otjtf">
            {feature.included ? <span aria-hidden="true" className="flex-none leading-[1.5] text-[#12A05A]" data-id="element-56" data-mp="203klg92j945d">
                ✓
              </span> : <span aria-hidden="true" className="flex-none leading-[1.5] text-ink/40" data-id="element-57" data-mp="2512o5hpyin4x">
                ✗
              </span>}
            <span className={feature.included ? feature.bold ? 'font-extrabold text-ink' : 'text-ink' : 'text-ink/40 line-through'} data-id="element-58" data-mp="1w3s9dmdxkfv9">
              {feature.label}
            </span>
          </li>)}
      </ul>

      <button type="button" onClick={event => {
      event.stopPropagation();
      onSelect();
      onCheckout();
    }} className={recommended ? 'mt-6 w-full rounded-[999px] bg-[#12A05A] px-5 py-4 text-[16px] font-extrabold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-[#0E8C4E] active:translate-y-[1px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink' : 'mt-6 w-full rounded-[999px] border-2 border-ink bg-transparent px-5 py-4 text-[16px] font-extrabold text-ink transition-[background-color,transform] duration-150 ease-out hover:bg-ink/5 active:translate-y-[1px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink'} data-id="element-59" data-mp="3bhoe9bxdwm8u">
        {recommended ? 'Get Complete →' : 'Get Starter'}
      </button>
    </div>;
}